/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../core/models/Node';
import { IDefinition } from '../core/models/common/IDefinition';
import { IExample } from '../core/models/common/IExample';
import { IPropertySchema } from '../core/models/common/IPropertySchema';
import { Operation } from '../core/models/common/Operation';
import { Parameter } from '../core/models/common/Parameter';
import { Schema } from '../core/models/common/Schema';
import { SecurityRequirement } from '../core/models/common/SecurityRequirement';
import { SecurityScheme } from '../core/models/common/SecurityScheme';
import { OasDocument } from '../openapi/models/OasDocument';
import { OasHeader } from '../openapi/models/OasHeader';
import { OasPathItem } from '../openapi/models/OasPathItem';
import { OasPaths } from '../openapi/models/OasPaths';
import { OasResponse } from '../openapi/models/OasResponse';
import { OasResponses } from '../openapi/models/OasResponses';
import { OasSchema } from '../openapi/models/OasSchema';
import { OasXML } from '../openapi/models/OasXML';
import { Oas20Definitions } from '../openapi/v2/models/Oas20Definitions';
import { Oas20Document } from '../openapi/v2/models/Oas20Document';
import { Oas20Headers } from '../openapi/v2/models/Oas20Headers';
import { Oas20Items } from '../openapi/v2/models/Oas20Items';
import { Oas20ParameterDefinitions } from '../openapi/v2/models/Oas20ParameterDefinitions';
import { Oas20Response } from '../openapi/v2/models/Oas20Response';
import { Oas20ResponseDefinitions } from '../openapi/v2/models/Oas20ResponseDefinitions';
import { Oas20Scopes } from '../openapi/v2/models/Oas20Scopes';
import { Oas20SecurityDefinitions } from '../openapi/v2/models/Oas20SecurityDefinitions';
import { IOas20Visitor } from '../openapi/v2/visitors/IOas20Visitor';
import { ModelClonerVisitor } from './ModelClonerVisitor';
import { Document } from '../core/models/Document';
import { OasOperation } from '../openapi/models/OasOperation';
import { OasParameter } from '../openapi/models/OasParameter';
import { Oas20Header } from '../openapi/v2/models/Oas20Header';
import { Oas20ResponseDefinition } from '../openapi/v2/models/Oas20ResponseDefinition';
import { Oas20Example } from '../openapi/v2/models/Oas20Example';
import { Oas20ParameterDefinition } from '../openapi/v2/models/Oas20ParameterDefinition';
import { Oas20SchemaDefinition } from '../openapi/v2/models/Oas20SchemaDefinition';
import { OasSecurityRequirement } from '../openapi/models/OasSecurityRequirement';
import { Oas20SecurityScheme } from '../openapi/v2/models/Oas20SecurityScheme';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ModelClonerVisitor
 */
export class Oas20ModelClonerVisitor extends ModelClonerVisitor implements IOas20Visitor {
    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPaths(io.apicurio.datamodels.openapi.models.OasPaths)
     * @param {OasPaths} node
     */
    public visitPaths(node : OasPaths) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPathItem(io.apicurio.datamodels.openapi.models.OasPathItem)
     * @param {OasPathItem} node
     */
    public visitPathItem(node : OasPathItem) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem(node.getPath());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponse(io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {OasResponse} node
     */
    public visitResponse(node : OasResponse) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createResponses().createResponse(node.getStatusCode());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponses(io.apicurio.datamodels.openapi.models.OasResponses)
     * @param {OasResponses} node
     */
    public visitResponses(node : OasResponses) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createResponses();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitXML(io.apicurio.datamodels.openapi.models.OasXML)
     * @param {OasXML} node
     */
    public visitXML(node : OasXML) {
        this.__clone = (<OasSchema>(<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createParameter().createSchema()).createXML();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAllOfSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAllOfSchema(node : OasSchema) {
        this.__clone = node.createAllOfSchema();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitItemsSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitItemsSchema(node : OasSchema) {
        this.__clone = (<OasSchema>(<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createParameter().createSchema()).createItemsSchema();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAdditionalPropertiesSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAdditionalPropertiesSchema(node : OasSchema) {
        this.__clone = (<OasSchema>(<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createParameter().createSchema()).createAdditionalPropertiesSchema();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPropertySchema(io.apicurio.datamodels.core.models.common.IPropertySchema)
     * @param {*} node
     */
    public visitPropertySchema(node : IPropertySchema) {
        this.__clone = (<OasSchema>(<OasDocument>(<Node><any>node).ownerDocument()).createPaths().createPathItem("").createOperation(null).createParameter().createSchema()).createPropertySchema(node.getPropertyName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitHeader(io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {OasHeader} node
     */
    public visitHeader(node : OasHeader) {
        this.__clone = (<Oas20Response>(<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createResponses().createDefaultResponse()).createHeaders().createHeader(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponseDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitResponseDefinition(node : IDefinition) {
        this.__clone = (<Oas20Document>(<Node><any>node).ownerDocument()).createResponseDefinitions().createResponse(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
        this.__clone = (<Oas20Document>(<Node><any>node).ownerDocument()).createResponseDefinitions().createResponse("").createExample();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(node.getType());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.__clone = (<Oas20Document>(<Node><any>node).ownerDocument()).createParameterDefinitions().createParameter(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createParameter();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitSchemaDefinition(node : IDefinition) {
        this.__clone = (<Oas20Document>(<Node><any>node).ownerDocument()).createDefinitions().createSchemaDefinition(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchema(io.apicurio.datamodels.core.models.common.Schema)
     * @param {Schema} node
     */
    public visitSchema(node : Schema) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createParameter().createSchema();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     * @param {SecurityRequirement} node
     */
    public visitSecurityRequirement(node : SecurityRequirement) {
        this.__clone = (<OasDocument>node.ownerDocument()).createSecurityRequirement();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        this.__clone = (<Oas20Document>(<Node>node).ownerDocument()).createSecurityDefinitions().createSecurityScheme(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitItems(io.apicurio.datamodels.openapi.v2.models.Oas20Items)
     * @param {Oas20Items} node
     */
    public visitItems(node : Oas20Items) {
        this.__clone = (<Oas20Document>(<Node>node).ownerDocument()).createDefinitions().createSchemaDefinition("").createItemsSchema();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitScopes(io.apicurio.datamodels.openapi.v2.models.Oas20Scopes)
     * @param {Oas20Scopes} node
     */
    public visitScopes(node : Oas20Scopes) {
        this.__clone = (<Oas20Document>(<Node>node).ownerDocument()).createSecurityDefinitions().createSecurityScheme("").createScopes();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitSecurityDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20SecurityDefinitions)
     * @param {Oas20SecurityDefinitions} node
     */
    public visitSecurityDefinitions(node : Oas20SecurityDefinitions) {
        this.__clone = (<Oas20Document>(<Node>node).ownerDocument()).createSecurityDefinitions();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20Definitions)
     * @param {Oas20Definitions} node
     */
    public visitDefinitions(node : Oas20Definitions) {
        this.__clone = (<Oas20Document>(<Node>node).ownerDocument()).createDefinitions();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitParameterDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ParameterDefinitions)
     * @param {Oas20ParameterDefinitions} node
     */
    public visitParameterDefinitions(node : Oas20ParameterDefinitions) {
        this.__clone = (<Oas20Document>(<Node>node).ownerDocument()).createParameterDefinitions();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitHeaders(io.apicurio.datamodels.openapi.v2.models.Oas20Headers)
     * @param {Oas20Headers} node
     */
    public visitHeaders(node : Oas20Headers) {
        this.__clone = (<Oas20Document>(<Node>node).ownerDocument()).createResponseDefinitions().createResponse("").createHeaders();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitResponseDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ResponseDefinitions)
     * @param {Oas20ResponseDefinitions} node
     */
    public visitResponseDefinitions(node : Oas20ResponseDefinitions) {
        this.__clone = (<Oas20Document>(<Node>node).ownerDocument()).createResponseDefinitions();
    }

    constructor() {
        super();
    }
}
Oas20ModelClonerVisitor["__class"] = "io.apicurio.datamodels.cloning.Oas20ModelClonerVisitor";
Oas20ModelClonerVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




